import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ApplicationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const jobTitle = location.state?.jobTitle || 'the position';

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
          <svg 
            className="w-8 h-8 text-green-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M5 13l4 4L19 7" 
            />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Application Submitted!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for applying for <span className="font-semibold">{jobTitle}</span>. 
          Your application has been received and our HR team will review it shortly.
        </p>
        
        <p className="text-gray-600 mb-8">
          We'll contact you via email if your profile matches our requirements.
        </p>
        
        <button
          onClick={() => navigate('/')}
          className="bg-[#275F97] hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition-colors duration-300"
        >
          View More Jobs
        </button>
      </div>
    </div>
  );
};

export default ApplicationSuccess;